import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.limited = false))
  }, _toDisplayString(_ctx.limitedText), 1))
}